import { Chess } from "chess.js";
import { BOOK_ENTRIES, BOOK_SOURCE } from "./book.generated";

export interface BookMoveEvidence {
  /** Named position reached by this move; null for unnamed book transitions. */
  documentedIn: { eco: string; name: string } | null;
  source: typeof BOOK_SOURCE;
}

export const bookMoveReference = (evidence: BookMoveEvidence | null): string | null =>
  evidence?.documentedIn?.name ?? null;

const book = new Map(BOOK_ENTRIES.map(([key, eco, name]) => [key, eco && name ? { eco, name } : null]));
const uciPattern = /^[a-h][1-8][a-h][1-8][qrbn]?$/;

const positionKey = (fen: string): string => new Chess(fen).fen().split(" ").slice(0, 4).join(" ");

export function lookupBookMove(fen: string, uci: string): BookMoveEvidence | null {
  if (!uciPattern.test(uci)) return null;
  try {
    const position = positionKey(fen);
    const chess = new Chess(fen);
    const move = chess.move({ from: uci.slice(0, 2), to: uci.slice(2, 4), promotion: uci[4] });
    if (!move) return null;
    const opening = book.get(`${position} ${uci}`);
    return opening !== undefined ? { documentedIn: opening, source: BOOK_SOURCE } : null;
  } catch {
    return null;
  }
}

export const filterUnverifiedBookMotifs = (motifs: readonly string[]): string[] =>
  motifs.filter((motif) => motif !== "book");

export function deriveVerifiedBookMotifs(motifs: readonly string[], evidence: BookMoveEvidence | null): string[] {
  const verified = filterUnverifiedBookMotifs(motifs);
  return evidence ? [...verified, "book"] : verified;
}
